// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 381) return "static/chunks/381-241dd67528f37bef.js";
	if (chunkId === 983) return "static/chunks/983-14112c04ce4df76a.js";
	if (chunkId === 228) return "static/chunks/228-ff4179847c65fcb7.js";
	if (chunkId === 761) return "static/chunks/761-63f5c4f14877f771.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"43":"98dda1bbeeb02b5e","57":"d78dbbffb1275646","210":"9ddf77d9896fd9f7","239":"ce459d0fdc7a954b","633":"b215c376a0e5e2ea","814":"7e3b3ab30f993917","908":"ccc59648827bc9e5","920":"5b7c83a3c238e29d","987":"97c83e0b9a4edab6"}[chunkId] + ".js";
};